import { toast } from "react-toastify";
import Axios from "../Axios";

export const getGratuitySettings = async () => {
    try {
        const res = await Axios.get(`setting/gratuity/show`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        toast.warn("Something went wrong");
    }
};

export const postGratuitySettings = async (data) => {
    try {
        const res = await Axios.post(`setting/gratuity`, data, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        toast.warn("Something went wrong");
    }
};

export const getProvidendSettings = async () => {
    try {
        const res = await Axios.get(`setting/provident-fund/show`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        toast.warn("Something went wrong");
    }
};

export const postProvidentSettings = async (data) => {
    try {
        const res = await Axios.post(`setting/provident-fund`, data, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        toast.warn("Something went wrong");
    }
};

export const getFinalSettlement = async (id) => {
    try {
        const res = await Axios.get(`employee/settlement-related-data/${id}`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        toast.warn("Something went wrong");
    }
};

export const getMRExpense = async (id) => {
    try {
        const res = await Axios.get(`market-expense/show/${id}`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        toast.warn("Something went wrong");
    }
};


export const lunchAllowanceSettings = async (data) => {
    try {
        const res = await Axios.post(`lunch-allowance/create`, data, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        toast.warn("Something went wrong");
    }
};

export const getLunchAllowanceSettings = async () => {
    try {
        const res = await Axios.get(`lunch-allowance`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        toast.warn("Something went wrong");
    }
};

export const getSettings = async (settings = []) => {
    try {
        const res = await Axios.post(`all/setting`, { name: settings }, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        });

        return res.data;
    } catch (error) {
        console.log("error", error);
        toast.warn("Something went wrong");
    }
};